import { User } from 'src/app/shared/models/user.model';
import { TransferMode } from './withdraw.model';
import { loadHashUpdate } from '@ton/core';

export enum Provider {
  jibit = 'JIBIT',
  vandar = 'VANDAR',
  'zibal' = 'ZIBAL',
  'novinpal' = 'NOVINPAL',
  'parsian' = 'PARSIAN'
}

export class WithdrawRial {
  id: number;
  user: User;
  amount: number;
  selectedWithdraw: boolean;
  userIban: string;
  jibitStatus:
    | 'INITIALIZED'
    | 'CANCELLING'
    | 'CANCELLED'
    | 'IN_PROGRESS'
    | 'TRANSFERRED'
    | 'TRANSFERRED_PARTIAL'
    | 'FAILED'
    | 'OTHER';
  status!: 'PENDING' | 'CHECKED_BY_OPERATOR' | 'SUCCESSFUL' | 'ERROR';
  provider!: Provider;
  jibitStatusText!: string;
  callbackTrackingCode: string;
  bankTransferId: string;
  fee: number;
  createdAt: string;
  transferMode!: TransferMode;

  constructor(input: any = {}) {
    this.user = new User(input.user);
    this.id = input.id;
    this.userIban = input.user_iban;
    this.jibitStatus = input.jibit_status;
    switch (input.provider) {
      case 'jibit':
        this.provider = Provider.jibit;
        break;
      case 'vandar':
        this.provider = Provider.vandar;
        break;
      case 'zibal':
        this.provider = Provider.zibal;
        break;
      case 'novinpal':
        this.provider = Provider.novinpal;
        break;
      default:
        this.provider = input.provider;
    }
    if (this.jibitStatus === 'INITIALIZED') {
      this.jibitStatusText = 'شروع شده';
    }
    if (this.jibitStatus === 'CANCELLING') {
      this.jibitStatusText = 'در حال کنسل';
    }
    if (this.jibitStatus === 'CANCELLED') {
      this.jibitStatusText = 'کنسل شده';
    }
    if (this.jibitStatus === 'IN_PROGRESS') {
      this.jibitStatusText = 'در حال انجام';
    }
    if (this.jibitStatus === 'TRANSFERRED') {
      this.jibitStatusText = 'انجام شده';
    }
    if (this.jibitStatus === 'TRANSFERRED_PARTIAL') {
      this.jibitStatusText = 'انجام شده ناقص';
    }
    if (this.jibitStatus === 'FAILED') {
      this.jibitStatusText = 'با خطا مواجه شده';
    }
    if (this.jibitStatus === 'OTHER') {
      this.jibitStatusText = 'نامشخحص';
    }
    this.status = input.status;


    this.callbackTrackingCode = input.callback_tracking_code;
    this.bankTransferId = input.bank_transfer_id;
    this.amount = Math.round(input.amount / 10);
    this.fee = input.fee;
    this.createdAt = input.created_at;
    this.transferMode = input.transferMode;
    this.transferMode = TransferMode.NORMAL;
    this.selectedWithdraw = false;
  }
}
